import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ProfileForm } from "@/pages/gate/ProfilesPage";

import { cn } from "@/utils/cn";

import Button from "../buttons/Button";
import { IconCheck } from "../icons";

const ChooseGender = () => {
  const {
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<ProfileForm>();

  const { t } = useTranslation();
  const gender = watch("gender");

  const genderOptions = [
    { gender: "M", text: t("Gender.male") },
    { gender: "W", text: t("Gender.female") },
  ];

  return (
    <>
      <label className="mb-2 block">{t("Gender.choose")}</label>
      <div className="space-y-3">
        {genderOptions.map(({ gender: optionGender, text }) => (
          <Button
            key={optionGender}
            color="black"
            size="medium"
            className={cn(
              "flex flex-row-reverse items-center justify-between border border-transparent text-start transition-all hover:bg-surface-container-high active:bg-surface-container-high",
              {
                " border-orange-1": gender === optionGender,
              },
            )}
            icon={
              <IconCheck
                className={cn("size-6 !fill-transparent stroke-transparent transition-all", {
                  "stroke-orange-1": gender === optionGender,
                })}
              />
            }
            onClick={() => {
              setValue("gender", optionGender as "W" | "M");
              clearErrors("gender");
            }}
          >
            {text}
          </Button>
        ))}
      </div>
      {errors.gender && <p className="mt-2 text-sm text-red-500">{errors.gender.message}</p>}
    </>
  );
};

export default ChooseGender;
